{
  "name": "@databricks/sdk-core",
  "version": "0.21.0",
  "description": "Databricks core library for JavaScript/TypeScript",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "default": "./dist/index.js"
    },
    "./profiles": {
      "types": "./dist/profiles/index.d.ts",
      "import": "./dist/profiles/index.js",
      "default": "./dist/profiles/index.js"
    },
    "./profiles/browser": {
      "types": "./dist/profiles/index.browser.d.ts",
      "import": "./dist/profiles/index.browser.js",
      "default": "./dist/profiles/index.browser.js"
    },
    "./wkt": {
      "types": "./dist/wkt/index.d.ts",
      "import": "./dist/wkt/index.js",
      "default": "./dist/wkt/index.js"
    },
    "./clientinfo": {
      "browser": {
        "types": "./dist/clientinfo/index.browser.d.ts",
        "import": "./dist/clientinfo/index.browser.js",
        "default": "./dist/clientinfo/index.browser.js"
      },
      "default": {
        "types": "./dist/clientinfo/index.d.ts",
        "import": "./dist/clientinfo/index.js",
        "default": "./dist/clientinfo/index.js"
      }
    },
    "./clientinfo/browser": {
      "types": "./dist/clientinfo/index.browser.d.ts",
      "import": "./dist/clientinfo/index.browser.js",
      "default": "./dist/clientinfo/index.browser.js"
    },
    "./http": {
      "types": "./dist/http/index.d.ts",
      "import": "./dist/http/index.js",
      "default": "./dist/http/index.js"
    },
    "./logger": {
      "types": "./dist/logger/index.d.ts",
      "import": "./dist/logger/index.js",
      "default": "./dist/logger/index.js"
    },
    "./ops": {
      "types": "./dist/ops/index.d.ts",
      "import": "./dist/ops/index.js",
      "default": "./dist/ops/index.js"
    },
    "./apierror": {
      "types": "./dist/apierror/index.d.ts",
      "import": "./dist/apierror/index.js",
      "default": "./dist/apierror/index.js"
    },
    "./apierror/codes": {
      "types": "./dist/apierror/codes/index.d.ts",
      "import": "./dist/apierror/codes/index.js",
      "default": "./dist/apierror/codes/index.js"
    }
  },
  "files": [
    "dist",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsc -b",
    "lint": "eslint src tests --ext .ts",
    "lint:fix": "eslint src tests --ext .ts --fix",
    "format": "prettier --write \"src/**/*.ts\" \"tests/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\" \"tests/**/*.ts\"",
    "test": "vitest run",
    "test:browser": "vitest run --config vitest.config.browser.ts",
    "typecheck": "tsc --noEmit",
    "clean": "rm -rf dist tsconfig.tsbuildinfo"
  },
  "author": "Databricks",
  "license": "Apache-2.0",
  "engines": {
    "node": ">=22.0.0"
  },
  "dependencies": {
    "json-bigint": "^1.0.0",
    "zod": "^4.3.6"
  }
}
